<template>
  <BreadCrumb PageTitle="Mes Colis (Stock)" />
  <EditProdColis :id="id"  />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import EditProdColis from "../../components/Stock/EditProdColis.vue";
import { useRoute } from "vue-router";
export default defineComponent({
  name: "EditProdColisPage",
  components: {
    BreadCrumb,
    EditProdColis,
  },

  setup: () => {
    const route = useRoute();
    let id = route.params.id;  // <-- get the id
    if (Array.isArray(id)) {
      id = id[0] ?? "";
    }


    return { id };
}
});
</script>